import { downloadUrl, DownloadURLOptions } from '@apis/common';
import { useMutation } from '@hooks/useMutation';

export const useDownloadAndCompress = () => {
  return useMutation(async (files: DownloadURLOptions[]): Promise<Blob> => {
    const downloads = await Promise.all(files.map((f) => downloadUrl(f)));

    const { default: JSZip } = await import('jszip');

    const zip = new JSZip();

    let i = 0;
    for (const download of downloads) {
      zip.file(files[i].name, download, { binary: true });

      i++;
    }

    return zip.generateAsync({ type: 'blob' });
  });
};
